import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { AITranslationState } from '../type/ai-translation.type';
import { Step } from '../type/ai-translation.enum';

export const AITranslationModel = Symbol('AITranslationModel');

export interface AITranslationModel extends AbstractModel<AITranslationState> { }

@injectable()
export class AITranslationModelImpl extends AbstractModelImpl<AITranslationState> implements AITranslationModel {
    protected _modelData: AITranslationState = {
        isInitializing: true,
        taskId: '',
        step: Step.ORIGINAL_INPUT,
        taskType: undefined,
        showDrawer: false,
        title: '',
        result: [],
        updatedAt: '',
    };
}
